<template>
    <v-container style="margin: 60px 10%">
      <vueHeadful
      :title="this.$i18n.t('Menu.Eventos') + ' - TrArtist'"
      :url="'https://trartist.com' + $route.fullPath"
      />
      <v-row>
        <v-col cols="12" align="center" style="margin-bottom: 5%">
          <h1 :style="responsiveTitulo" class="titulo">{{$t('Menu.Eventos')}}</h1>
        </v-col>
        <v-col cols="12">
          <v-sheet height="500">
            <v-calendar
              type="month"
              :events="eventos"
              color="error"
              event-color="primary"
              :locale="getIdioma"
              @click:event="mostrarEvento"
              :event-name="getIdioma === 'es' ? 'tituloEs' : 'tituloEn'"
              event-start="inicio"
              event-end="final"
            ></v-calendar>
          </v-sheet>
        </v-col>
        <v-dialog v-model="dialog" class="dialogEventos">
          <v-card v-if="eventoElegido">
            <v-card-title>
              <v-container style="padding: 40px 0">
                <v-row>
                  <v-col cols="12" xs="12" lg="6">
                    <v-img :src="eventoElegido.imagen" max-height="600px" />
                  </v-col>
                  <v-col cols="12" xs="12" lg="6">
                    <v-row>
                      <v-col cols="12">
                        <h2 v-if="getIdioma === 'es'" style="word-break:break-word;">{{eventoElegido.tituloEs}}</h2>
                        <h2 v-else style="word-break:break-word;" >{{eventoElegido.tituloEn}}</h2>
                      </v-col>
                      <v-col cols="12">
                        <span>{{$t('Formularios.Del')}} <b>{{eventoElegido.inicio}}</b></span>
                        <br>
                        <span>{{$t('Formularios.Al')}} <b>{{eventoElegido.final}}</b></span>
                      </v-col>
                      <v-col cols="12">
                        <div style="word-break:break-word;" v-if="getIdioma === 'es'" v-html="eventoElegido.descripcionEs"/>
                        <div style="word-break:break-word;" v-else v-html="eventoElegido.descripcionEn"/>
                      </v-col>
                      <v-col cols="12" align="center">
                        <v-btn class="ma-3" outlined style="border: 2px solid" x-large @click="dialog = false">{{$t('Formularios.Cerrar')}}</v-btn>
                        <v-btn class="ma-3" color="primary white--text" x-large :href="eventoElegido.enlace" target="_blank">{{$t('Formularios.IrEnlace')}}</v-btn>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-title>
          </v-card>
        </v-dialog>
      </v-row>
    </v-container>
</template>

<script>
import * as firebase from 'firebase/app'
import 'firebase/firestore'
import { mapGetters } from 'vuex'
export default {
  name: 'Eventos',
  data () {
    return {
      eventos: [],
      dialog: false,
      eventoElegido: null
    }
  },
  mounted () {
    firebase.firestore().collection('eventos').get().then(info => {
      for (let i = 0; i < info.docs.length; i++) {
        this.eventos.push(info.docs[i].data())
      }
    })
  },
  methods: {
    mostrarEvento (evento) {
      this.eventoElegido = evento.event
      this.dialog = true
    }
  },
  computed: {
    ...mapGetters(['getIdioma']),
    responsiveTitulo () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 'font-size:2rem;line-height:2rem;'
        case 'sm': return 'font-size:3rem;line-height:3rem;'
        case 'md': return 'font-size:3rem;line-height:3rem;'
        case 'lg': return 'font-size:4rem;line-height:4rem;'
        case 'xl': return 'font-size:4rem;line-height:4rem;'
        default: return 'font-size:4rem;line-height:4rem;'
      }
    }
  }
}
</script>
<style>
.v-dialog {
  max-width:80%!important;
}
</style>
